var dgsDiscountScripts						= {};
// Protein Aktion 25%
var scriptID = "198377658";
dgsDiscountScripts[scriptID] 				= {};
dgsDiscountScripts[scriptID]["codes"] 		= [];
dgsDiscountScripts[scriptID]["tags"] 		= [];
dgsDiscountScripts[scriptID]["products"] 	= [6865128390842,6865152868538];
dgsDiscountScripts[scriptID]["types"] 		= ["percent","percent"];
dgsDiscountScripts[scriptID]["values"] 		= [25,25];
dgsDiscountScripts[scriptID]["specials"] 	= []